export const validateDomain = (domain: string) => {
  if (!/^[a-zA-Z0-9.-]{3,}$/.test(domain)) {
    return false
  }

  const numberOfDots = domain.match(/\./g)?.length || 0

  return !!domain && numberOfDots <= 1
}
